module.exports = __webpack_public_path__ + "img/SketchPng939c4943e2f8acdbf484792c3849860d6a019f961923747514e6cbcc65fc8b5c.649d8790.png";